import { COLOR_CODE, COLOR_NAME } from '@/constant';

/**
 * カラーコードを色名に変換
 * @param {ColorCode} colorCode 色名 - paleGreyなど
 */
export function convertColorCodeToColorName(colorCode: string) {
  if (typeof colorCode !== 'string') return '';
  let color = '';
  switch (colorCode) {
    // pale
    case COLOR_CODE.PALE.GREY:
      color = COLOR_NAME.PALE.GREY;
      break;
    case COLOR_CODE.PALE.SCARLET:
      color = COLOR_NAME.PALE.SCARLET;
      break;
    case COLOR_CODE.PALE.LIGHT_BLUE:
      color = COLOR_NAME.PALE.LIGHT_BLUE;
      break;
    case COLOR_CODE.PALE.LIGHT_GREEN:
      color = COLOR_NAME.PALE.LIGHT_GREEN;
      break;
    case COLOR_CODE.PALE.PURPLE:
      color = COLOR_NAME.PALE.PURPLE;
      break;
    case COLOR_CODE.PALE.ORANGE:
      color = COLOR_NAME.PALE.ORANGE;
      break;
    case COLOR_CODE.PALE.BLUE:
      color = COLOR_NAME.PALE.BLUE;
      break;
    case COLOR_CODE.PALE.GREEN:
      color = COLOR_NAME.PALE.GREEN;
      break;
    case COLOR_CODE.PALE.MAGENTA:
      color = COLOR_NAME.PALE.MAGENTA;
      break;
    case COLOR_CODE.PALE.YELLOW:
      color = COLOR_NAME.PALE.YELLOW;
      break;
    case COLOR_CODE.PALE.BLUE_VIOLET:
      color = COLOR_NAME.PALE.BLUE_VIOLET;
      break;
    case COLOR_CODE.PALE.CYAN:
      color = COLOR_NAME.PALE.CYAN;
      break;
    case COLOR_CODE.PALE.RED:
      color = COLOR_NAME.PALE.RED;
      break;
    case COLOR_CODE.PALE.CORAL:
      color = COLOR_NAME.PALE.CORAL;
      break;
    case COLOR_CODE.PALE.DODGER_BLUE:
      color = COLOR_NAME.PALE.DODGER_BLUE;
      break;
    case COLOR_CODE.PALE.SEA_GREEN:
      color = COLOR_NAME.PALE.SEA_GREEN;
      break;
    case COLOR_CODE.PALE.VIOLET:
      color = COLOR_NAME.PALE.VIOLET;
      break;
    case COLOR_CODE.PALE.GOLD:
      color = COLOR_NAME.PALE.GOLD;
      break;
    case COLOR_CODE.PALE.NAVY:
      color = COLOR_NAME.PALE.NAVY;
      break;
    case COLOR_CODE.PALE.TURQUOISE:
      color = COLOR_NAME.PALE.TURQUOISE;
      break;
    case COLOR_CODE.PALE.PINK:
      color = COLOR_NAME.PALE.PINK;
      break;
    case COLOR_CODE.PALE.GREEN_YELLOW:
      color = COLOR_NAME.PALE.GREEN_YELLOW;
      break;
    case COLOR_CODE.PALE.INDIGO:
      color = COLOR_NAME.PALE.INDIGO;
      break;
    case COLOR_CODE.PALE.SKY_BLUE:
      color = COLOR_NAME.PALE.SKY_BLUE;
      break;
    case COLOR_CODE.PALE.SALMON:
      color = COLOR_NAME.PALE.SALMON;
      break;
    case COLOR_CODE.STRONG.STEEL_GREY:
      color = COLOR_NAME.STRONG.STEEL_GREY;
      break;
    case COLOR_CODE.STRONG.SEPIA:
      color = COLOR_NAME.STRONG.SEPIA;
      break;
    case COLOR_CODE.STRONG.BROWN:
      color = COLOR_NAME.STRONG.BROWN;
      break;
    case COLOR_CODE.STRONG.MAROON:
      color = COLOR_NAME.STRONG.MAROON;
      break;
    case COLOR_CODE.STRONG.PURPLE:
      color = COLOR_NAME.STRONG.PURPLE;
      break;
    case COLOR_CODE.STRONG.PANSY:
      color = COLOR_NAME.STRONG.PANSY;
      break;
    case COLOR_CODE.STRONG.SAXE_BLUE:
      color = COLOR_NAME.STRONG.SAXE_BLUE;
      break;
    case COLOR_CODE.STRONG.ORIENTAL_BLUE:
      color = COLOR_NAME.STRONG.ORIENTAL_BLUE;
      break;
    case COLOR_CODE.STRONG.COBALT_BLUE:
      color = COLOR_NAME.STRONG.COBALT_BLUE;
      break;
    case COLOR_CODE.STRONG.CERULEAN_BLUE:
      color = COLOR_NAME.STRONG.CERULEAN_BLUE;
      break;
    case COLOR_CODE.STRONG.ROYAL_BLUE:
      color = COLOR_NAME.STRONG.ROYAL_BLUE;
      break;
    case COLOR_CODE.STRONG.MARINE_BLUE:
      color = COLOR_NAME.STRONG.MARINE_BLUE;
      break;
    case COLOR_CODE.STRONG.MALACHITE_GREEN:
      color = COLOR_NAME.STRONG.MALACHITE_GREEN;
      break;
    case COLOR_CODE.STRONG.GREEN:
      color = COLOR_NAME.STRONG.GREEN;
      break;
    case COLOR_CODE.STRONG.EMERALD_GREEN:
      color = COLOR_NAME.STRONG.EMERALD_GREEN;
      break;
    case COLOR_CODE.STRONG.GRASS_GREEN:
      color = COLOR_NAME.STRONG.GRASS_GREEN;
      break;
    case COLOR_CODE.STRONG.YELLOW_OCHER:
      color = COLOR_NAME.STRONG.YELLOW_OCHER;
      break;
    case COLOR_CODE.STRONG.DEEP_ORANGE:
      color = COLOR_NAME.STRONG.DEEP_ORANGE;
      break;
    case COLOR_CODE.STRONG.CARROT_ORANGE:
      color = COLOR_NAME.STRONG.CARROT_ORANGE;
      break;
    case COLOR_CODE.STRONG.GOLDEN_YELLOW:
      color = COLOR_NAME.STRONG.GOLDEN_YELLOW;
      break;
    case COLOR_CODE.STRONG.FIREBRICK:
      color = COLOR_NAME.STRONG.FIREBRICK;
      break;
    case COLOR_CODE.STRONG.ROSE:
      color = COLOR_NAME.STRONG.ROSE;
      break;
    case COLOR_CODE.STRONG.OLD_ROSE:
      color = COLOR_NAME.STRONG.OLD_ROSE;
      break;
    case COLOR_CODE.STRONG.STRAWBERRY:
      color = COLOR_NAME.STRONG.STRAWBERRY;
      break;
  }
  return color;
}

export default convertColorCodeToColorName;
